<template>
  <div class="row" id="newsletter">
    <div class="col-sm-12 mb-3">
      <legend>{{ $t("newsletter.legend") }}</legend>
      <br />
      <div
        class="nl-promo"
        :style="{
          background: `url(${newsletterBlurred}) no-repeat`,
          backgroundSize: 'cover',
        }"
      >
        <div class="nl-promo__badge">{{ $t("newsletter.freeBook") }}</div>
        <img
          :src="newletterImg"
          alt="Gratis Fachbuch"
          class="nl-promo__cover"
        />
        <div class="nl-promo__block">
          <h4>{{ $t("newsletter.introduction.heading") }}</h4>
          {{ $t("newsletter.introduction.text") }}
        </div>
      </div>
      <div class="form-group">
        <div class="text-center">
          <label class="mb-1 primary-text-color">{{
            $t("newsletter.subscribe.label")
          }}</label
          ><br />
          <div class="btn-group" data-toggle="buttons">
            <button
              class="btn btn-outline-secondary custom-active"
              @click.prevent="updateValue('subscribeNewsletter', true)"
              :class="{ active: value.subscribeNewsletter }"
            >
              {{ $t("common.yes") }}
            </button>
            <button
              class="btn btn-outline-secondary custom-active"
              @click.prevent="updateValue('subscribeNewsletter', false)"
              :class="{ active: !value.subscribeNewsletter }"
            >
              {{ $t("common.no") }}
            </button>
          </div>
        </div>
      </div>
      <CollapseTransition>
        <div id="newsletterForm" v-if="value.subscribeNewsletter">
          <div class="form-group mb-3">
            <label class="control-label primary-text-color"
              ><strong class="primary-text-color">{{
                $t("newsletter.form.label")
              }}</strong></label
            >
            <input
              :placeholder="$t('newsletter.form.placeholder')"
              name="newsletter_email"
              type="text"
              class="form-control"
              aria-label="..."
              :value="value.email"
              @change="updateValue('email', $event.target.value)"
            />
          </div>
          <div class="row">
            <div class="col-sm-6">
              <label
                class="primary-text-color"
                style="font-size: 13px; padding-left: 20px"
              >
                <input
                  type="checkbox"
                  data-validate="hasEmail"
                  name="newsletterOptions[]"
                  style="margin: 5px 0 0 -20px; position: absolute"
                  v-model="newsletterChoices[0]"
                  :true-value="newsletterOptions[0]"
                  :false-value="null"
                  @change="updateChoices"
                />
                <span
                  class="primary-text-color"
                  style="font-size: 16px; font-weight: bold"
                  >{{ $t("newsletter.form.option1.heading") }}</span
                ><br />
                <span class="primary-text-color">{{
                  $t("newsletter.form.option1.text")
                }}</span>
              </label>

              <label
                class="primary-text-color"
                style="font-size: 13px; padding-left: 20px"
              >
                <input
                  type="checkbox"
                  name="newsletterOptions[]"
                  data-validate="hasEmail"
                  style="margin: 5px 0 0 -20px; position: absolute"
                  v-model="newsletterChoices[1]"
                  :true-value="newsletterOptions[1]"
                  :false-value="null"
                  @change="updateChoices"
                />
                <span
                  class="primary-text-color"
                  style="font-size: 16px; font-weight: bold"
                  >{{ $t("newsletter.form.option2.heading") }}</span
                ><br />
                <span
                  class="primary-text-color"
                  v-html="$t('newsletter.form.option2.text')"
                ></span>
              </label>
            </div>
            <div class="col-sm-6">
              <label
                class="primary-text-color"
                style="font-size: 13px; padding-left: 20px"
              >
                <input
                  type="checkbox"
                  name="newsletterOptions[]"
                  data-validate="hasEmail"
                  style="margin: 5px 0 0 -20px; position: absolute"
                  v-model="newsletterChoices[2]"
                  :true-value="newsletterOptions[2]"
                  :false-value="null"
                  @change="updateChoices"
                />
                <span
                  class="primary-text-color"
                  style="font-size: 16px; font-weight: bold"
                  >{{ $t("newsletter.form.option3.heading") }}</span
                ><br />
                <span v-html="$t('newsletter.form.option3.text')"></span>
              </label>
            </div>
          </div>
        </div>
      </CollapseTransition>
    </div>
  </div>
</template>

<script>
import newletterImg from "../assets/images/newsletter.jpg";
import newsletterBlurred from "../assets/images/newsletter_blurred.jpg";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";

export default {
  components: {
    CollapseTransition,
  },
  props: ["value"],
  data: function () {
    return {
      newletterImg,
      newsletterBlurred,
      subscribeNewsletter: false,
      newsletterOptions: ["voucher", "consent", "enrichment"],
      newsletterChoices: [false, false, false],
    };
  },
  methods: {
    updateValue(field, newValue) {
      this.$emit("input", {
        ...this.value,
        [field]: newValue,
      });
    },
    updateChoices() {
      const checkedValues = this.newsletterChoices
        .map((isChecked, index) =>
          isChecked ? this.newsletterOptions[index] : null
        )
        .filter((value) => value !== null);
      this.$emit("input", {
        ...this.value,
        newsletterOptions: checkedValues,
      });
    },
  },
};
</script>
